<script setup lang="ts">
import { type PropType } from 'vue';
import { type MapLayerGroup } from '@common';

defineProps({
  selectedLayerGroup: {
    type: Object as PropType<MapLayerGroup>,
    required: true
  }
});

const emits = defineEmits(['onSubLayerSelect']);

const onSubLayerSelect = (data: any) => {
  const layerId = data.id.layerId;
  const subLayerId = data.id.subLayerId;
  emits('onSubLayerSelect', layerId, subLayerId);
};
</script>

<template>
  <v-menu
    v-if="selectedLayerGroup.subLayers.length > 1"
    :activator-props="{ size: 'x-small', variant: 'flat', density: 'comfortable' }">
    <template v-slot:activator="{ props }">
      <v-btn
        v-bind="props"
        :icon="true">
        <v-tooltip
          activator="parent"
          :text="$t('map.subLayers')"
          location="top" />
        <v-icon
          icon="mdi-layers"
          size="x-large" />
      </v-btn>
    </template>
    <v-list @click:select="onSubLayerSelect">
      <v-list-item
        v-for="(subLayer, s) in selectedLayerGroup.subLayers"
        :active="subLayer.enabled"
        :key="s"
        :value="{ layerId: selectedLayerGroup.id, subLayerId: subLayer.id }">
        <v-list-item-title>{{ subLayer.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
